import React from 'react';
import BlogPost from './blogPost';
import Display from './parts/display';

class BlogBlock extends React.Component {
    constructor() {
        super();
        this.state = {

        };

        this.showBlogPost = this.showBlogPost.bind(this);
        this.formatDate = this.formatDate.bind(this);
    }
    componentDidMount() {

    }
    componentWillReceiveProps(next) {
        var _this = this;
    }
    formatDate(dateString) {
        var monthNames = [
            "January", "February", "March",
            "April", "May", "June", "July",
            "August", "September", "October",
            "November", "December"
        ];

        var date = new Date(dateString);
        var day = date.getDate();
        var monthIndex = date.getMonth();
        var year = date.getFullYear();

        return day + ' ' + monthNames[monthIndex] + ' ' + year;
    }
    showBlogPost(post, index) {
        //console.log(post);
        if (this.props.currentId == post.id) {
            return false;
        }
        else if (index < this.props.maxPosts) {
            return <BlogPost
                key={index}
                title={post.title.rendered}
                excerpt={post.excerpt.rendered}
                date={this.formatDate(post.date)}
                image={post.better_featured_image ? post.better_featured_image.media_details.sizes.medium.source_url : url + 'img/placeholder1.jpg'}
                id={post.id}
                slug={post.slug}
            />
        } else {
            return false;
        }
    }
    render() {
        return (

            <div className="blog-section">
                <div className="container">
                    <div className="row">
                        <Display if={this.props.related}>
                            <h3>Recent Posts</h3>
                        </Display>
                        <Display if={!this.props.related}>
                            <h3>Blog</h3>
                        </Display>
                        <div className="blog-posts row">
                            {this.props.posts.map(this.showBlogPost)}
                            <Display if={this.props.loading} className="blog-post-loading blog-post col-md-4">
                                <div className="title"></div>
                                <div className="date"></div>
                                <div className="image"></div>
                                <div className="text"></div>
                                <div className="read-more"></div>
                            </Display>
                            <Display if={this.props.loading} className="blog-post-loading blog-post col-md-4">
                                <div className="title"></div>
                                <div className="date"></div>
                                <div className="image"></div>
                                <div className="text"></div>
                                <div className="read-more"></div>
                            </Display>
                            <Display if={this.props.loading} className="blog-post-loading blog-post col-md-4">
                                <div className="title"></div>
                                <div className="date"></div>
                                <div className="image"></div>
                                <div className="text"></div>
                                <div className="read-more"></div>
                            </Display>

                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default BlogBlock;



/** WEBPACK FOOTER **
 ** ./src/js/components/blogBlock.js
 **/